<template>
  <div>
    <a-modal
      centered
      :maskClosable="false"
      title="报表权限"
      v-model="visible"
      width="60%"
      @ok="handleOk"
    >
      <div style="height: calc(100vh - 250px)">
        <a-layout id="components-layout-demo-side" style="height: 100%">
          <a-layout-sider>
            <a-tree
              style="overflow:auto;height:100%"
              :treeData="treeData"
              @select="onSelect"
              :selectedKeys.sync="selectedKeys"
            ></a-tree>
          </a-layout-sider>
          <a-layout>
            <div>
              <div style="padding:8px;background: white;">
                <a-button
                  style="margin-left:5px"
                  type="primary"
                  @click="selectAll(true)"
                  >全选</a-button
                >
                <a-button
                  style="margin-left:10px"
                  type="primary"
                  @click="selectAll(false)"
                  >取消全选</a-button
                >
              </div>
              <data-grid
                :columns="columns"
                v-model="dataShow"
                rowKey="Code"
                bordered
              />
              <!-- {{data}} -->
            </div>
          </a-layout>
        </a-layout>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";

export default {
  name: "groupRoleReportQermission",
  components: { DataGrid },
  props: {
    roleId: {
      type: String,
      default: ""
    },
    companyId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      selectedKeys: [],
      treeData: [],
      data: [], //所有数据
      dataShow: [], //右边展示数据
      columns: [
        {
          title: "名称",
          dataIndex: "Name",
          width: "200px"
        },
        {
          title: "浏览",
          dataIndex: "CanPreview",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "打印",
          dataIndex: "CanPrint",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "导出",
          dataIndex: "CanExport",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "移动端",
          dataIndex: "CanMobile",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        }
      ]
    };
  },
  created() {
    this.$post("GroupRole_GetCompanyReportGroups", {
      CompanyId: this.companyId
    }).then(res => {
      let arr = [{ key: 0, title: "全部" }];
      res.Data.forEach(item => {
        arr.push({ key: item.Id, title: item.Name });
      });
      this.treeData = arr;
    });
    this.$post("GroupRole_GetReportPermissions", { RoleId: this.roleId }).then(
      res => {
        this.selectedKeys = [];
        this.data = res.Data;
        this.dataShow = this.data;
      }
    );
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    onCancel() {
      this.$emit("destroy");
    },
    //选择的树节点
    onSelect(selectedKeys) {
      this.dataShow = [];
      if (selectedKeys == "0") this.dataShow = this.data;
      else {
        this.data.forEach(item => {
          if (item.ReportGroupId == selectedKeys) this.dataShow.push(item);
        });
      }
    },
    selectAll(value) {
      this.dataShow.forEach(item => {
        item.CanExport = value;
        item.CanMobile = value;
        item.CanPreview = value;
        item.CanPrint = value;
      });
    },
    handleOk() {
      this.data.forEach(item => {
        item.RoleId = this.roleId;
      });
      this.$post("GroupRole_SetRoleReportDataPermission", this.data).then(
        () => {
          this.$message.info("操作成功");
          this.visible = false;
        }
      );
    }
  },
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
